/* Parches y personalizacion de la ficha.

   Shopify no sabe cobrar un extra sobre una propiedad de linea. Por eso el
   recargo entra al carrito como un producto aparte, con dos variantes:
   «Jugador de la plantilla» y «Tu nombre». Lo que se elige aqui decide
   cual de las dos se agrega.

   El nombre y el numero SI viajan como propiedades de linea sobre la
   camisa (properties[Nombre] y properties[Numero]), no sobre el recargo:
   asi aparecen pegados a la prenda en el carrito, en el pago, en el
   correo de confirmacion y en la orden del panel. El recargo lleva su
   propia propiedad «Para» para que en el panel se entienda a que camisa
   pertenece y no quede una linea suelta de mil colones sin contexto.

   Los parches de cada equipo viven en tlr-plantillas.js. Los jugadores ya
   no: el cliente escribe el nombre y el numero del jugador. */
(function () {
  "use strict";

  var caja = document.querySelector("[data-opciones]");

  /* La barra pegada vive aunque no haya personalizacion. */
  (function () {
    var barra = document.querySelector("[data-sticky]");
    var boton = document.querySelector("[data-agregar]");
    if (!barra || !boton || !("IntersectionObserver" in window)) { return; }
    var io = new IntersectionObserver(function (f) {
      var r = f[0];
      barra.classList.toggle("on", !r.isIntersecting && r.boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(boton);
    barra.addEventListener("click", function (ev) {
      if (ev.target.closest("[data-sticky-add]")) {
        boton.scrollIntoView({ block: "center", behavior: "smooth" });
      }
    });
  })();

  if (!caja) { return; }

  var handle = caja.getAttribute("data-opciones");
  var parchesBase = caja.getAttribute("data-parches-url");
  var zonaParches = caja.querySelector("[data-zona-parches]");
  var form = document.getElementById("form-producto");

  /* El titulo de la camisa, para etiquetar la linea del recargo. */
  var tituloEl = document.querySelector(".pdp-info h1");
  var titulo = tituloEl ? tituloEl.textContent.trim() : "";

  var esc = function (s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  };

  var sel = { parche: "Sin parches", modo: "sin" };

  /* ── Parches ──────────────────────────────────────────────
     Con foto. Ver el parche antes de elegirlo evita la pregunta «cual
     me va a llegar?», que es la que llegaba por WhatsApp. */
  function pintarParches(lista) {
    if (!lista || lista.length < 2 || !zonaParches) { return; }
    var opts = zonaParches.querySelector("[data-opts]");
    opts.innerHTML = lista.map(function (o, k) {
      var corto = o.v.replace("Parches de ", "");
      corto = corto.charAt(0).toUpperCase() + corto.slice(1);
      var img = o.i && parchesBase
        ? '<img class="par-img" src="' + parchesBase + o.i + '.webp" alt="" loading="lazy" onerror="this.remove()">'
        : '<span class="par-img par-nada" aria-hidden="true"></span>';
      return '<button type="button" class="par" data-par="' + esc(o.v) + '" aria-pressed="' + (k === 0) + '">' +
             img + '<b>' + esc(corto) + '</b></button>';
    }).join("");
    zonaParches.hidden = false;

    opts.addEventListener("click", function (ev) {
      var b = ev.target.closest("[data-par]");
      if (!b) { return; }
      Array.prototype.forEach.call(opts.querySelectorAll("[data-par]"), function (x) {
        x.setAttribute("aria-pressed", "false");
      });
      b.setAttribute("aria-pressed", "true");
      sel.parche = b.getAttribute("data-par");
      zonaParches.querySelector("[data-valor]").textContent = sel.parche;
    });
  }

  /* ── Las pestañas: Sin nombre · Un jugador · Tu nombre (esta ultima no
     sale en NBA, NFL ni MLB; la decide main-producto.liquid) ────────── */
  var pestanas = caja.querySelector("[data-modos]");
  if (pestanas) {
    pestanas.addEventListener("click", function (ev) {
      var b = ev.target.closest("[data-modo]");
      if (!b) { return; }
      sel.modo = b.getAttribute("data-modo");
      Array.prototype.forEach.call(pestanas.querySelectorAll("[data-modo]"), function (x) {
        x.setAttribute("aria-pressed", String(x === b));
      });
      Array.prototype.forEach.call(caja.querySelectorAll("[data-panel]"), function (pn) {
        pn.hidden = pn.getAttribute("data-panel") !== sel.modo;
      });
    });
  }

  /* Lee un par de campos nombre/numero; si falta el nombre, lo marca. */
  function leer(ev, nombreSel, numeroSel) {
    var campo = caja.querySelector(nombreSel);
    var campoN = caja.querySelector(numeroSel);
    var n = campo ? campo.value.trim() : "";
    if (!n) {
      ev.preventDefault();
      if (campo) {
        campo.focus();
        campo.classList.add("es-error");
        setTimeout(function () { campo.classList.remove("es-error"); }, 1600);
      }
      return null;
    }
    return { nombre: n.toUpperCase(), numero: campoN ? campoN.value.trim() : "" };
  }

  /* ── Al agregar al carrito ──────────────────────────────── */
  if (form) {
    form.addEventListener("submit", function (ev) {
      var props = {};
      if (sel.parche && sel.parche !== "Sin parches") { props["Parches"] = sel.parche; }

      var extra = null;
      var queExtra = "";
      var dato = null;
      if (sel.modo === "jugador") {
        dato = leer(ev, "[name='pers-jug-nombre']", "[name='pers-jug-numero']");
        if (!dato) { return; }
        extra = caja.getAttribute("data-var-jugador");
      } else if (sel.modo === "propio") {
        dato = leer(ev, "[name='pers-nombre']", "[name='pers-numero']");
        if (!dato) { return; }
        extra = caja.getAttribute("data-var-propio");
      }
      if (dato) {
        props["Nombre"] = dato.nombre;
        if (dato.numero) { props["Numero"] = dato.numero; }
        queExtra = dato.nombre + (dato.numero ? " " + dato.numero : "");
      }

      if (!Object.keys(props).length && !extra) { return; }

      ev.preventDefault();
      var boton = form.querySelector("[data-agregar]");
      var rotulo = boton ? boton.textContent : "";
      if (boton) { boton.disabled = true; boton.textContent = "Agregando..."; }

      var items = [{ id: Number(form.querySelector("[data-variante]").value), quantity: 1, properties: props }];

      if (extra) {
        /* «Para» se ve en el carrito y en la orden; «_tlr_padre» empieza
           con guion bajo, asi que Shopify la guarda pero no la muestra
           a nadie. Sirve para rastrear de que camisa vino el recargo. */
        var propsExtra = { "_tlr_padre": handle };
        if (titulo) { propsExtra["Para"] = titulo + (queExtra ? " — " + queExtra : ""); }
        items.push({ id: Number(extra), quantity: 1, properties: propsExtra });
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) { throw new Error("no"); }
        /* Aviso para quien escuche — hoy, la barra de envio gratis. */
        document.dispatchEvent(new CustomEvent("tlr:carrito"));
        location.href = "/cart";
      }).catch(function () {
        if (boton) { boton.disabled = false; boton.textContent = rotulo; }
        form.submit();
      });
    });
  }

  /* ── Los datos (parches) ─────────────────────────────── */
  var datos = window.TLR_DATOS;
  var reg = datos && datos.h && datos.h[handle] !== undefined ? datos.g[datos.h[handle]] : null;
  if (reg) { pintarParches(reg.pa); }
})();